import { render, staticRenderFns } from "./BackOffice.vue?vue&type=template&id=21d2780f&"
import script from "./BackOffice.vue?vue&type=script&lang=ts&"
export * from "./BackOffice.vue?vue&type=script&lang=ts&"
import style0 from "./BackOffice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports